
import React from 'react';
import { Button } from '@/components/ui/button';
import { Check, Printer } from 'lucide-react';

interface PaymentSuccessProps {
  teacherName: string;
  amount: number;
  paymentPeriod: string;
  onClose: () => void;
  onPrint?: () => void;
}

export const PaymentSuccess = ({ teacherName, amount, paymentPeriod, onClose, onPrint }: PaymentSuccessProps) => {
  return (
    <div className="text-center py-8">
      <div className="mx-auto w-16 h-16 rounded-full bg-green-100 flex items-center justify-center mb-6">
        <Check className="h-10 w-10 text-green-600" />
      </div>
      <h2 className="text-2xl font-bold mb-2">Payment Successful</h2>
      <p className="text-gray-500 mb-6">
        {amount.toFixed(2)} AFN has been successfully paid to {teacherName} for {paymentPeriod}.
      </p>
      <div className="flex flex-col sm:flex-row justify-center gap-2">
        {onPrint && (
          <Button onClick={onPrint} variant="outline" className="mb-2 sm:mb-0">
            <Printer className="mr-2 h-4 w-4" /> Print Receipt
          </Button>
        )}
        <Button onClick={onClose}>Close</Button>
      </div>
    </div>
  );
};
